import React from "react";
import { Link } from "react-router-dom";
import LogoMark from "@/components/LogoMark";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer className="border-t border-white/10 bg-ink-900 mt-24" data-testid="site-footer">
            <div className="mx-auto max-w-7xl px-6 md:px-12 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <LogoMark size={52} />
                        <p className="mt-6 text-white/60 max-w-sm leading-relaxed">
                            Labor consulting for unions that fight. Grievances, contracts,
                            organizing, arbitrations, strike support &amp; training — from
                            first contact to first contract.
                        </p>
                        <div className="mt-8 heraldic-divider">
                            <span className="text-xs tracking-[0.3em] uppercase">Solidarity Forever</span>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="label-tag mb-4">Services</div>
                        <ul className="space-y-3 text-sm">
                            {[
                                ["Grievances", "grievance-writing-training"],
                                ["Bargaining", "contract-negotiation"],
                                ["Organizing", "external-organizing"],
                                ["Arbitrations", "arbitrations"],
                                ["Strike Support", "strike-support"],
                            ].map(([label, slug]) => (
                                <li key={slug}>
                                    <Link
                                        to={`/services/${slug}`}
                                        className="text-white/70 hover:text-gold-500 transition-colors"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="label-tag mb-4">Company</div>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/about" className="text-white/70 hover:text-gold-500">About</Link></li>
                            <li><Link to="/blog" className="text-white/70 hover:text-gold-500">Journal</Link></li>
                            <li><Link to="/contact" className="text-white/70 hover:text-gold-500">Contact</Link></li>
                            <li><Link to="/booking" className="text-white/70 hover:text-gold-500">Book</Link></li>
                            <li><Link to="/login" className="text-white/70 hover:text-gold-500">Portal</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="label-tag mb-4">Contact</div>
                        <ul className="space-y-3 text-sm text-white/70">
                            <li className="flex items-start gap-2">
                                <Mail size={16} className="mt-0.5 text-gold-500" />
                                BradshawSolutions@gmail.com
                            </li>
                            <li className="flex items-start gap-2">
                                <Phone size={16} className="mt-0.5 text-gold-500" />
                                (555) 010-1848
                            </li>
                            <li className="flex items-start gap-2">
                                <MapPin size={16} className="mt-0.5 text-gold-500" />
                                Serving unions nationwide
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
                    <div>© {new Date().getFullYear()} Bradshaw Solutions. All rights reserved.</div>
                    <div className="tracking-[0.3em] uppercase text-gold-500/80">Created by Kevin Bradshaw</div>
                </div>
            </div>
        </footer>
    );
}
